import React, { useEffect, useRef } from 'react';

const Section = ({ content, videoRef, sectionClass = 'fade-section' }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
            videoRef.current && videoRef.current.parentElement.classList.add('dim');
          } else {
            entry.target.classList.remove('show');
            videoRef.current && videoRef.current.parentElement.classList.remove('dim');
          }
        });
      },
      {
        threshold: 0.5,
        rootMargin: '0px 0px 0px 0px',
      }
    );

    sectionRef.current && observer.observe(sectionRef.current);

    return () => {
      observer.disconnect();
    };
  }, [videoRef]);

  return (
    <section ref={sectionRef} className={`about-section ${sectionClass}`}>
      {content}
    </section>
  );
};

export default Section;
